import React from 'react';

import { cx } from '@travel/utils';

import styles from './smallToggleButton.module.scss';

import type { ChangeEvent } from 'react';
type Props = {
  /** style class name to change appearance of this component */
  className?: string;
  /** control active or inactive status */
  isActive: boolean;
  /** control if toggle can be changed or not */
  isDisabled?: boolean;
  /** field name */
  name: string;
  /** callback func to be called on every change */
  onChange: (events: ChangeEvent<HTMLInputElement>) => void;
};

function SmallToggleButton(props: Props) {
  const { className, isActive, isDisabled, name, onChange, ...rest } = props;

  return (
    <label
      className={cx(className, styles.switch)}
      data-testid="smallToggleButton-wrapper"
      {...rest}
    >
      <input
        type="checkbox"
        role="switch"
        name={name}
        className={styles.toggle}
        checked={isActive}
        disabled={isDisabled}
        onChange={onChange}
      />
      <div
        className={cx(
          styles.slider,
          styles.round,
          isActive ? styles.active : styles.inactive,
          isDisabled && styles.disabled,
        )}
      />
    </label>
  );
}

export default SmallToggleButton;
